<template>
    <div class="register-form">
        <ModalHeader title="회원가입"  :close-action="goBack"/>
        <div style="flex:1; overflow:auto; overflow-x: hidden;">
            <div style="padding:0px 20px;">
                <div style="height:20px; "></div>

                <div v-show="step === 0">
                    <div style="max-width: 170px;" class="form-group">
                        <label class="required">이름</label>
                        <input
                                type="text"
                                v-model="formData.name"
                                ref="member_name"
                                enterkeyhint="next"
                                @keyup="next($event, 'jumin_el')"
                        >
                    </div>

                    <div style="max-width: 250px;" class="form-group">
                        <label class="required">주민번호</label>
                        <input
                                type="text"
                                v-model="formData.jumin"
                                maxlength="14"
                                ref="jumin_el"
                                inputmode="numeric"
                        >
                    </div>

                    <div class="form-group">
                        <label class="required">성별</label>
                        <div style="display:flex; gap: 42px;" ref="gender_wrap">
                            <div :style="{backgroundColor: formData.gender === '남' ? 'var(--color-main)' : '#fff'}" class="gender_wrapper" @click="setGender('남')">
                                <!-- <div style="position:relative; border-radius:50%; width:20px; height:20px; border:1px solid #BBBBBB;">
                                    <div v-if="formData.gender === '남'" style="width:14px; height:14px; border-radius:50%; background-color: #2196F3; position:absolute; left:2px; top:2px;"></div>
                                </div> -->
                                <div style="color:#210F03;font-weight:500;" :style="{color: formData.gender === '남' ? '#fff' : ''}">남</div>
                            </div>
                            <div :style="{backgroundColor: formData.gender === '여' ? 'var(--color-main)' : '#fff'}" class="gender_wrapper" @click="setGender('여')">
                                <!-- <div style="position:relative; border-radius:50%; width:20px; height:20px; border:1px solid #BBBBBB;">
                                    <div v-if="formData.gender === '여'" style="width:14px; height:14px; border-radius:50%; background-color: #2196F3; position:absolute; left:2px; top:2px;"></div>
                                </div> -->
                                <div style="color:#210F03;font-weight:500;" :style="{color: formData.gender === '여' ? '#fff' : ''}">여</div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="required">휴대폰번호</label>
                        <div class="phone-input-group" style="display:flex;">
                            <input
                                    type="text"
                                    v-model="formData.phone"
                                    style="outline: none; width: inherit; width: 220px;"
                                    ref="phone_el"
                                    maxlength="13"
                                    inputmode="numeric"
                                    :readonly="isVerified"
                            >
                            <ProgressButton
                                    :buttonText="isShowVerificationInput ? '재전송' : '인증번호전송'"
                                    :showProgress="isSendingCode"
                                    @click="sendVerificationCode"
                                    :customFontSize="'16px'"
                                    style="margin-top:0px; width:120px; margin-left: -20px;"
                            />
                        </div>
                    </div>

                    <div class="form-group" v-if="isShowVerificationInput">
                        <label class="required">인증번호</label>
                        <div style="display: flex;"  class="verification-input-group">
                            <input
                                    type="text"
                                    v-model="formData.authNumber"
                                    maxlength="6"
                                    style="width: 150px; outline: none;"
                                    :readonly="isVerified"
                                    inputmode="numeric"
                            >
                            <div style="width: 70px;">
                                <ProgressButton
                                        :buttonText="isVerified ? '인증됨' : '확인'"
                                        :showProgress="isVerifying"
                                        @click="verifyCode"
                                        :customFontSize="'16px'"
                                        style="margin-top: 0; margin-left: -20px;"
                                        :style="{backgroundColor : isVerified ? 'gray' : ''}"
                                />
                            </div>
                        </div>
                    </div>
                    <div style="width: 110px; margin: 0 auto; margin-top: 50px;">
                        <ProgressButton
                            buttonText="다음"
                            @click="goNextStep"
                            :customFontSize="'24px'"
                            style="margin-top:0px;"
                        />
                    </div>
                </div>
                <div v-show="step === 1">
                    <div style="max-width: 230px;" class="form-group">
                        <label class="required">비상 연락처</label>
                        <div class="phone-input-group" style="display:flex;">
                            <input
                                    type="tel"
                                    v-model="formData.phone2"
                                    style="flex:1;"
                                    ref="phone_el2"
                                    maxlength="13"
                            >
                        </div>
                    </div>

                    <div style="max-width: 250px;" class="form-group">
                        <label class="required">급여 통장 은행</label>
                        <select style="border-radius: 12px; box-shadow: 0 0px 8px rgba(0, 0, 0, 0.2);" v-model="formData.bank_name" ref="bank_name_el">
                            <option v-for="each, i in BANKS" :key="i" :value="each.name">{{each.name}}</option>
                        </select>
                    </div>

                    <div style="max-width: 250px;" class="form-group">
                        <label class="required">급여 통장 번호</label>
                        <input
                                type="text"
                                v-model="formData.bank_account"
                                ref="bank_account_el"
                                inputmode="numeric"
                                enterkeyhint="next"
                        >
                    </div>

                    <div style="max-width: 250px;" class="form-group">
                        <label >차량 번호 (선택)</label>
                        <input
                                type="text"
                                v-model="formData.car_number"
                                ref="car_number"
                                placeholder=""
                                enterkeyhint="next"
                        >
                    </div>

                    <div class="form-group">
                        <label class="required">신분증 사본</label>
                        <div>
                            <ProgressButton
                                    :buttonText="is_image_uploaded ? '재업로드' : '업로드'"
                                    @click="selectFile"
                                    style="margin-top:0px;"
                                    :customFontSize="'16px'"
                            />
                            <input type="file" ref="image_file" style="display:none;" :capture="!is_ios" @change="readURL($event, 'image_preview')"/>
                            <img ref="image_preview" style="margin-top:10px; border-radius:4px; width:100%;"/>
                        </div>
                    </div>
                    <div style="width: 110px; margin: 0 auto; margin-top: 20px; margin-bottom: 20px;">
                        <ProgressButton
                            buttonText="다음"
                            @click="goNextStep"
                            :customFontSize="'24px'"
                            style="margin-top:0px;"
                        />
                    </div>
                </div>

                <div v-show="step === 2" id="member_register_print" >
                    <div style="text-align:center; font-size:20px; font-weight:bold;">개인정보 수집 및 이용 동의서</div>
                    <div style="font-size:16px; font-weight:bold; margin-top:40px;">[개인정보 수집 항목 및 목적]</div>
                    <div class="agree_each_wrap" style="margin-top:15px;">
                        <div class="agree_numbering">1.</div>
                        <div style="white-space: pre-wrap;" class="agree_label">수집항목: <span class="agree_right" style="font-weight:500;">이름, 주민등록번호(또는 생년월일), 연락처, 계좌번호</span></div>
                    </div>
                    <div class="agree_each_wrap">
                        <div class="agree_numbering">2.</div>
                        <div>
                            <div class="agree_label">수집 및 이용목적 :</div>
                            <div class="agree_right_sub">1) 근로자 식별 및 연락</div>
                            <div class="agree_right_sub">2) 임금 지급 및 세금 신고</div>
                            <div class="agree_right_sub">3) 작업 평가 및 관리</div>
                        </div>

                    </div>
                    <div class="agree_each_wrap">
                        <div class="agree_numbering">3.</div>
                        <div>
                            <div class="agree_label">보관 기간 : <span class="agree_right" style="font-weight:500;">회원 탈퇴 후 1년 (법적 의무 기간)</span></div>
                        </div>

                    </div>
                    <div class="agree_each_wrap">
                        <div class="agree_numbering">4.</div>
                        <div>
                            <div class="agree_label">개인정보 제3자 제공 여부 : <span class="agree_right" style="font-weight:500;">없음</span></div>
                        </div>

                    </div>

                    <div style="text-align:center; margin-top:30px; font-size:18px;font-weight:bold;">{{today_str}}</div>
                    <div style="margin-top: 80px; display: flex; justify-content: center;">
                        <ProgressButton
                                v-if="step === 2"
                                buttonText="동의하기"
                                :showProgress="isSubmitting"
                                @click="submit"
                                style="margin-top:0px; width: 118px;"
                                :customFontSize="'24px'"
                        />
                    </div>
                </div>

            </div>
          <!--  <div class="form-group">
                <label for="id">아이디</label>
                <input
                    type="text"
                    id="id"
                    v-model="formData.id"
                    placeholder="아이디를 입력하세요"
                    @keyup="next($event, 'password_el1')"
                    enterkeyhint="next"
                >
            </div>

            <div class="form-group">
                <label for="password">비밀번호</label>
                <input
                    type="password"
                    id="password"
                    v-model="formData.password"
                    ref="password_el1"
                    placeholder="비밀번호를 입력하세요"
                    @keyup="next($event, 'password_el2')"
                    enterkeyhint="next"
                >
            </div>

            <div class="form-group">
                <label for="passwordConfirm">비밀번호 확인</label>
                <input
                    type="password"
                    id="passwordConfirm"
                    v-model="formData.passwordConfirm"
                    ref="password_el2"
                    placeholder="비밀번호를 다시 입력하세요"
                    @keyup="enter($event)"
                    enterkeyhint="done"
                >
                <span v-if="!passwordsMatch" class="error-message">비밀번호가 일치하지 않습니다</span>
            </div>

            <ProgressButton
                    buttonText="가입하기"
                    :showProgress="isSubmitting"
                    @click="handleSubmit"
            />-->
        </div>
    </div>
</template>

<script>
import ProgressButton from '../common/ProgressButton.vue'
import ModalHeader from "../common/ModalHeader";
import {BANKS} from "../../Constants";
import ResponseCode from "../../ResponseCode";
import moment from 'moment'

export default {
    name: "MemberRegister",
    components: {
        ModalHeader,
        ProgressButton
    },
    props : {
        id : {
            type : [String, Number],
            default : ''
        },
        mode : {
            type : [String, Number],
            default : ''
        },
        completeAction : {
            type : Function,
            default : () => {}
        }
    },
    data() {
        return {
            step : 0,
            BANKS : BANKS,
            formData : {
                name : '',
                jumin : '',
                phone : '',
                authNumber : '',
                gender : '',
                bank_name : '',
                bank_account : '',
                phone2 : '',
                car_number : '',
            },
            isVerified : false,
            isSendingCode : false,
            isVerifying : false,
            isShowVerificationInput : false,
            is_image_uploaded : false,
            // formData: {
            //     id: '',
            //     password: '',
            //     passwordConfirm: '',
            //     name: '',
            //     phone: '',
            //     verificationCode: ''
            // },
            // showVerificationInput: false,
            isSubmitting: false,
            // isVerifying: false,
        }
    },
    computed: {
        is_ios(){
            const device = this.$cookies.get('device');
            return device === 'ios';
        },
        today_str(){
            return moment().format('YYYY년 MM월 DD일');
        }
        // passwordsMatch() {
        //     return this.formData.passwordConfirm.length === 0 || this.formData.password === this.formData.passwordConfirm
        // },
    },
    methods: {
        readURL(e, target) {
            target;
            const input = e.currentTarget;

            if (input.files && input.files[0]) {
                var extension = input.files[0].name.split('.').pop().toLowerCase();

                if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp') {

                    var reader = new FileReader();
                    reader.onload = (e) => {
                        this.$refs[target].src = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                    this.is_image_uploaded = true;
                } else {
                    this.$GlobalStore.showAlert('확장자 png, jpg, bmp만 업로드 가능합니다.');
                }
            }
        },
        selectFile(){
            this.$refs.image_file.click();
        },
        next(e, next_target_key){
            if(e.keyCode === 13){
                this.$refs[next_target_key].focus();
            }
        },
        goNextStep(){
            if(this.step === 0 && !this.validateStep0()) return;
            if(this.step === 1 && !this.validateStep1()) return;
            // if(!this.validateStep2()) return;
            this.step++;
        },
        async submit(){

            this.isSubmitting = true;

            /*eslint-disable no-undef */
            const canvas = await html2canvas(document.querySelector('#member_register_print'), {
                scale: 2,
            });
            const agreement_image_str = canvas.toDataURL('image/png').replace('data:image/png;base64,', '');

            const parameters = {};
            Object.assign(parameters, this.formData);

            const formData = new FormData();
            for(const key in parameters){
                console.log(key, parameters[key]);
                formData.append(key, parameters[key]);
            }

            formData.append('image_file', this.$refs.image_file.files[0]);
            formData.append('id', this.id);
            formData.append('mode', this.mode);
            formData.append('agreement_image_str', agreement_image_str);
            // console.log(formData);

            this.isSubmitting = true;
            const res = await this.$Axios.post('/api/member/regist', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            this.isSubmitting = false;
            if(res.data.code === ResponseCode.SUCCESS){
                this.$GlobalStore.closeLastModal();
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                await this.$Util.checkAfterLogin();
                this.completeAction();
            } else if(res.data.code === ResponseCode.FAIL){
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        validateStep0(){
            if(this.formData.name === ''){
                this.$GlobalStore.showAlert('이름을 입력해주세요.');
                this.$refs.member_name.focus();
                return;
            }

            if(this.formData.jumin === ''){
                this.$GlobalStore.showAlert('주민번호를 입력해주세요.');
                this.$refs.jumin_el.focus();
                return;
            }

            if(this.formData.jumin.length !== 14){
                this.$GlobalStore.showAlert('주민번호를 모두 입력해주세요.');
                this.$refs.jumin_el.focus();
                return;
            }

            const jumin_format = /\d{6}-\d{7}/gi;
            if(!jumin_format.test(this.formData.jumin)){
                this.$GlobalStore.showAlert('주민번호 형식이 맞지 않습니다.');
                this.$refs.jumin_el.focus();
                return;
            }

            if(this.formData.gender === ''){
                this.$GlobalStore.showAlert('성별을 선택해주세요.');
                this.$refs.gender_wrap.scrollIntoView({block : 'center'});
                return false;
            }

            if(!this.isVerified){
                this.$GlobalStore.showAlert('휴대폰번호를 인증해주세요.');
                this.$refs.phone_el.scrollIntoView({block : 'center'});
                return false;
            }

            return true;
        },
        validateStep1(){
            if(this.formData.bank_name === ''){
                this.$GlobalStore.showAlert('비상연락처를 입력해주세요.');
                this.$refs.bank_name_el.scrollIntoView({block : 'center'});
                return false;
            }

            const phone2_format = /\d{3}-\d{4}-\d{4}/gi;
            if(!phone2_format.test(this.formData.phone2)){
                this.$GlobalStore.showAlert('비상연락처의 휴대폰번호 형식이 맞지 않습니다.');
                this.$refs.phone_el2.focus();
                return;
            }


            if(this.formData.bank_name === ''){
                this.$GlobalStore.showAlert('급여통장 은행을 선택해주세요.');
                this.$refs.bank_name_el.scrollIntoView({block : 'center'});
                return false;
            }

            if(this.formData.bank_account === ''){
                this.$GlobalStore.showAlert('급여통장 번호를 입력해주세요.');
                this.$refs.bank_account_el.focus();
                return false;
            }

            if(this.$refs.image_file.value === ''){
                this.$GlobalStore.showAlert('신분증을 첨부해주세요.');
                return false;
            }

            return true;
        },
        async verifyCode(){
            if(this.isVerified) return;

            const parameters = {};
            parameters.phone = this.formData.phone;
            parameters.authNumber = this.formData.authNumber;
            this.isVerifying = true;
            const res = await this.$Axios.post('/api/auth/check', parameters);
            this.isVerifying = false;
            if(res.data.code === ResponseCode.SUCCESS){
                // this.$GlobalStore.showToast('인증되었습니다.');
                this.isVerified = true;
            } else if(res.data.code === ResponseCode.FAIL){
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async sendVerificationCode(){
            const parameters = {};
            parameters.phone = this.formData.phone;
            this.isSendingCode = true;
            const res = await this.$Axios.post('/api/auth/number', parameters);
            this.isSendingCode = false;
            if(res.data.code === ResponseCode.SUCCESS){
                this.$GlobalStore.showAlert('인증번호가 전송되었습니다.');
                this.isShowVerificationInput = true;
            } else if(res.data.code === ResponseCode.FAIL){
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        setGender(gender){
            console.log(gender);
            this.formData.gender = gender;
        },
        // next(e, next_target_key){
        //     if(e.keyCode === 13){
        //         this.$refs[next_target_key].focus();
        //     }
        // },
        // enter(e){
        //     if(e.keyCode === 13){
        //         this.handleSubmit();
        //     }
        // },
        // async handleSubmit() {
        //     if(this.formData.id === ''){
        //         this.$GlobalStore.showAlert('아이디를 입력해주세요.');
        //         return;
        //     }
        //
        //     if(this.formData.password === ''){
        //         this.$GlobalStore.showAlert('비밀번호를 입력해주세요.');
        //         return;
        //     }
        //
        //     if(this.formData.password !== this.formData.passwordConfirm){
        //         this.$GlobalStore.showAlert('비밀번호가 일치하지 않습니다.');
        //         return;
        //     }
        //
        //     //숫자 영문 특문 확인
        //     const pattern1 = /[0-9]/;				// 숫자
        //     const pattern2 = /[a-zA-Z]/;			// 문자
        //     const pattern3 = /[~!@#$%^&*()_+|<>?:{}]/;	// 특수문자
        //
        //     if ((!pattern1.test(this.formData.password) || !pattern2.test(this.formData.passwordConfirm) || !pattern3.test(this.formData.password)) && this.formData.password.length < 8) {
        //         this.$GlobalStore.showAlert('영문, 숫자, 특수문자 조합 8자리 이상 입력해주세요.');
        //         return
        //     }
        //
        //     this.isSubmitting = true;
        //
        //     const parameters = {};
        //     parameters.id = this.formData.id;
        //     parameters.password = this.formData.password;
        //
        //     const res = await this.$Axios.post('/api/member/regist', parameters);
        //     this.isSubmitting = false;
        //     if(res.data.code === ResponseCode.SUCCESS){
        //         this.$GlobalStore.setLoginInfo(res.data.loginInfo);
        //         this.$GlobalRouter.push('/view/reservation?' + new Date().getTime());
        //     }else if(res.data.code === ResponseCode.FAIL){
        //         this.$GlobalStore.showAlert(res.data.msg);
        //     }
        // },
        goBack(){
            this.$GlobalStore.closeLastModal();
        }
    },
    mounted(){
        this.$Util.setPhoneFormatter(this.$refs.phone_el);
        this.$Util.setPhoneFormatter(this.$refs.phone_el2);
        this.$Util.setJuminFormmater(this.$refs.jumin_el);
    },
    created(){
        // this.handleSubmit = this.$Once(this.handleSubmit);
        this.submit = this.$Once(this.submit);
    }
}
</script>

<style scoped>
.form-group {
    margin-bottom: 30px;
}

label {
    display: block;
    margin-bottom: 7px;
    font-weight: bold;
    color:var(--font-black-color);
}

/*label.required{*/
    /*color:#ff4b00;*/
/*}*/

.gender_wrapper {
    display:flex;
    align-items: center; 
    padding:12px 16px; 
    border-radius: 12px; 
    box-shadow: 0 0px 8px rgba(0, 0, 0, 0.2);
}

input {
    width: 100%;
    padding: 12px;
    /*border: 1px solid #ddd;*/
    border-radius: 12px;
    font-size: 14px;
    height: 44px;
    border: none;
    box-shadow: 0 0px 8px rgba(0, 0, 0, 0.2);
}


select {
    width: 100%;
    padding: 0px 6px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    height: 44px;
    background-color: white;
    color:black;
}

button {
    padding: 8px 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    height: 44px;
}

button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}

textarea{
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    height: 44px;
}

    .agree_each_wrap{margin-top:5px; white-space: nowrap; display:flex;}
    .agree_numbering{font-size:16px; font-weight:bold;line-height:24px; margin-right:5px;}
    .agree_label{font-size:16px; font-weight:bold;line-height:24px;}
    .agree_right{flex:1; white-space:pre-wrap; line-height:24px; font-size:16px;}
    .agree_right_sub{line-height:24px;font-size:16px;}
</style>